import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components'

import { Icon } from '../../components/Icon'

const Wrapper = styled.div`
  margin-top: 2rem;
  text-align: center;

  button {
    padding: 0.5rem;
    padding-bottom: 0;
    cursor: pointer;

    span {
      display: block;
      margin: 0 auto;
      margin-bottom: 0.5rem;
      font-weight: bold;
      color: red;
    }
  }
`;

const LogoutButton = (props) => (
  <Wrapper>
    <button onClick={props.onClick}>
      <Icon name="small--lock-open" />
      Kirjaudu ulos
    </button>
  </Wrapper>
);

LogoutButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default LogoutButton
